export interface CategoryResponse{
    id:string,
    nombre:string,
    descripccion:string | null,
}
export interface Categoria{
    id:string,
    nombre:string,
    descripccion:string | null,
}
export interface CategoryState {
    categories: CategoryResponse[];
}
export const SET_CATEGORIES = 'SET_CATEGORIES';
export interface SetCategoryAction {
    type: typeof SET_CATEGORIES;
    payload: CategoryResponse[];
}

export type CategoryActionTypes = SetCategoryAction;